export const SIGNATURE_MIME_TYPE = 'image/png';